import { createContext, useContext } from 'react';

const FilterDataContext = createContext(null);

export const useFilterDataContext = () => {
    const context = useContext(FilterDataContext);
    if (!context) {
        throw new Error("useFilterDataContext must be used within a FilterPanelProvider");
    }
    return context;
};

export default FilterDataContext;
